import { IUIStrings } from "./IUIStrings";

export const IT: IUIStrings =
{
  "PreparingMailCloning": "Preparazione per la clonazione della mail...",
  "CloningMail": "Clonazione della mail...",
  "MailCloned": "Mail clonata!",
  "AnErrorOccurred": "Si è verificato un errore, si prega di riprovare più tardi.",
  "ErrorWhileCloning": "Errore durante la clonazione della mail."
};

export default IT;